import React from 'react'
import { useTranslation } from 'react-i18next';
import '../../components/styles/AdvertiseChromemodal.css';
import googleImg from '../../img/chrome.png';

const AdvertiseChromeModal = ({ isModalOpen, onRequestClose }) => {
  const { t } = useTranslation();

  return (
    <>
        <div className='background-div'>
        </div>
        <div className='modal-div'>
            <button className='btn-close-modal' onClick={onRequestClose}>&times;</button>
            <p className='modal-content'>{t('wordings.downloadChrome')}</p>
            <img src={googleImg} alt='chrome' className='google-img' />
            <a className='anchor' href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">{t('wordings.chrome')}</a>
        </div>
    </>
  )
}

export default AdvertiseChromeModal;